import httpUtils from '../../utils/HttpUtils'

class CodeService {

  //根据种类查询code列表
  async getCodeList (category = '',status = '') {
    console.log('根据种类查询code列表');
    var result = null;
    try {
      result = await httpUtils.post('/core/code/category',{category,status});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
}
export default new CodeService()
